// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SimpleIntakeSurveyAnswerModel {
    static getAttributeTypeMap() {
        return SimpleIntakeSurveyAnswerModel.attributeTypeMap;
    }
}
SimpleIntakeSurveyAnswerModel.discriminator = undefined;
SimpleIntakeSurveyAnswerModel.additionalProperties = false;
SimpleIntakeSurveyAnswerModel.attributeTypeMap = [
    {
        "name": "questionId",
        "baseName": "questionId",
        "type": "number"
    },
    {
        "name": "answerId",
        "baseName": "answerId",
        "type": "number"
    },
    {
        "name": "value",
        "baseName": "value",
        "type": "string"
    },
];
//# sourceMappingURL=simpleIntakeSurveyAnswerModel.js.map